export default __webpack_public_path__ + "static/media/qtpi.cbb220d2.png";